import { DDSTypography } from 'den-design-system'
import React from 'react'
import ReactDOM from 'react-dom'
import pallete from '../../../global/newPallete'
import { useStoreContext } from '../../../store/StoreContext'

interface MentionDropdownProps {
  options: any[]
  onSelect: (item: any) => void
  top: number
  left: number
  upward?: boolean
}

const MentionDropdown: React.FC<MentionDropdownProps> = ({
  options,
  onSelect,
  top,
  left,
  upward = true
}) => {
  // Offsets to nudge the dropdown position
  const verticalOffset = 20 // upward shift
  const horizontalOffset = 24 // shift left

  const getUserInitials = (firstName: string, lastName: string) => {
    const firstInitial = firstName?.charAt(0)?.toUpperCase() || ''
    const lastInitial = lastName?.charAt(0)?.toUpperCase() || ''
    return `${firstInitial}${lastInitial}`
  }

  const store = useStoreContext()

  return ReactDOM.createPortal(
    <div
      className='mention-dropdown absolute z-50 bg-white p-[8px] border rounded shadow-md max-h-[200px] overflow-y-auto w-[300px]'
      style={{
        top: !upward ? top - verticalOffset : undefined,
        bottom: upward ? `calc(100% - ${top - verticalOffset}px)` : undefined,
        left: left - horizontalOffset
      }}
    >
      {options.map((item) => (
        <div
          key={item.userId}
          onClick={() => onSelect(item)}
          className='flex items-center px-[4px] py-[4px] hover:bg-gray-100 cursor-pointer'
        >
          {item.avatar ? (
            <img
              src={item.avatar}
              className='w-[24px] h-[24px] rounded-full mr-[12px]'
              alt={item.value}
            />
          ) : (
            <div
              className='rounded-full border aspect-square w-[24px] h-[24px] flex items-center justify-center bg-gradient-to-br mr-[12px]'
              style={{
                borderColor: pallete.colors.stroke2
              }}
            >
              <DDSTypography.Paragraph
                size='caption'
                variant='bold'
                color={pallete.colors.textDark3}
                style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                {getUserInitials(item.firstName, item.lastName)}
              </DDSTypography.Paragraph>
            </div>
          )}
          <span
            style={{
              fontSize: '14px',
              color: pallete.colors.textDark4,
              fontWeight: 500
            }}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>,
    document.body
  )
}

export default MentionDropdown
